import { helper } from '@ember/component/helper';

import { parseDate } from 'rise-ui/utils/date.js';

export default helper(function dateParseHelper([ date ]) {
  return parseDate(date) || '';
});
